//#region src/utils/themeTokens.ts
const format = (channels, alpha) => alpha === void 0 ? `rgb(${channels})` : `rgb(${channels} / ${alpha})`;
/**
* A semantic `--*` token as the `rgb(...)` the browser currently computes on `<html>`.
*
* - For consumers that need a concrete colour string, not a Tailwind class.
* - Falls back to `fallbackChannels` with no document or undefined token (tests load no CSS).
*/
const resolveToken = (token, fallbackChannels, alpha) => {
	const channels = typeof document === "undefined" ? fallbackChannels : getComputedStyle(document.documentElement).getPropertyValue(`--${token}`).trim() || fallbackChannels;
	return format(channels, alpha);
};
/** {@link createTokenResolver}, answering the raw `"R G B"` channels. */
const createChannelResolver = (from) => {
	const element = from ?? (typeof document === "undefined" ? null : document.documentElement);
	const computed = element === null ? null : getComputedStyle(element);
	return (token, fallbackChannels) => computed?.getPropertyValue(`--${token}`).trim() || fallbackChannels;
};
/**
* A {@link resolveToken} bound to one `getComputedStyle` snapshot, for building a whole palette.
*
* - Create one per palette build, never at module level — tokens change with scheme and brand.
*/
const createTokenResolver = (from) => {
	const resolve = createChannelResolver(from);
	return (token, fallbackChannels, alpha) => format(resolve(token, fallbackChannels), alpha);
};
//#endregion
export { createChannelResolver, createTokenResolver, resolveToken };

//# sourceMappingURL=themeTokens-7DEab0kp.js.map